import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import PersonaWidgets from './components/PersonaWidgets';
import TechStack from './components/TechStack';
import Footer from './components/Footer';
import ContactModal from './components/ContactModal';

export default function App() {
  const [darkMode, setDarkMode] = useState(true);
  const [isContactOpen, setIsContactOpen] = useState(false);

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-slate-100 selection:bg-brand-bronze selection:text-slate-950 font-sans transition-colors duration-300">
      
      {/* Header */}
      <Header 
        darkMode={darkMode} 
        setDarkMode={setDarkMode} 
        onOpenContact={() => setIsContactOpen(true)} 
      />

      {/* Main Content */}
      <main>
        <Hero onOpenContact={() => setIsContactOpen(true)} />
        <PersonaWidgets />
        <TechStack />
      </main>

      {/* Footer */}
      <Footer />

      {/* Contact Modal */}
      <ContactModal 
        isOpen={isContactOpen} 
        onClose={() => setIsContactOpen(false)} 
      />

    </div>
  );
}
